import { render, staticRenderFns } from "./AddGroupCourse.vue?vue&type=template&id=e62437b0&scoped=true&"
import script from "./AddGroupCourse.vue?vue&type=script&lang=js&"
export * from "./AddGroupCourse.vue?vue&type=script&lang=js&"
import style0 from "./AddGroupCourse.vue?vue&type=style&index=0&id=e62437b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62437b0",
  null
  
)

export default component.exports